import styled from "styled-components";
import {Modal, Button, Spin} from "antd";

export const StyledModal = styled(Modal)`
    .ant-modal-content {
        border-radius: 12px;
        box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.15);
        overflow: hidden;
    }

    .ant-modal-header {
        background: linear-gradient(135deg, #aeef01 0%, #9dd400 100%);
        border-bottom: none;
        padding: 20px 24px;
        border-radius: 12px 12px 0 0;

        .ant-modal-title {
            color: #000;
            font-weight: 600;
            font-size: 18px;
            margin: 0;
        }
    }

    .ant-modal-close {
        top: 16px;
        right: 16px;

        .ant-modal-close-x {
            color: #000;
            font-size: 16px;
            width: 32px;
            height: 32px;
            line-height: 32px;
            transition: all 0.3s ease;
            border-radius: 50%;

            &:hover {
                background-color: rgba(255, 255, 255, 0.2);
            }
        }
    }

    .ant-modal-body {
        padding: 24px;
        background: #fff;
    }

    .ant-modal-footer {
        border-top: 1px solid #f0f0f0;
        padding: 20px 24px;
        background: #fff;
        border-radius: 0 0 12px 12px;

        .ant-btn {
            height: 40px;
            border-radius: 6px;
            font-weight: 500;
            transition: all 0.3s ease;
            margin-left: 8px;

            &:first-child {
                margin-left: 0;
            }
        }

        .ant-btn-primary {
            background: #aeef01;
            border-color: #aeef01;
            color: #000;

            &:hover:not(:disabled) {
                background: #9dd400;
                border-color: #9dd400;
                transform: translateY(-1px);
                box-shadow: 0 4px 8px rgba(174, 239, 1, 0.3);
            }

            &:disabled {
                background: #f5f5f5;
                border-color: #d9d9d9;
                color: #bfbfbf;
            }
        }

        .ant-btn-default {
            border-color: #d9d9d9;
            color: #666;

            &:hover {
                border-color: #aeef01;
                color: #aeef01;
            }
        }
    }
`;

export const DocumentContainer = styled.div`
    position: relative;
    width: 100%;
    height: 500px;
    border-radius: 8px;
    overflow: hidden;
    background: #f8f9fa;
    border: 2px solid #e8e8e8;
`;

export const DocumentIframe = styled.iframe`
    width: 100%;
    height: 100%;
    border: none;
    border-radius: 8px;
`;

export const LoadingContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(4px);
    z-index: 10;
    border-radius: 8px;
`;

export const StyledSpin = styled(Spin)`
    .ant-spin-text {
        color: #666;
        font-weight: 500;
        margin-top: 12px;
    }

    .ant-spin-dot-item {
        background-color: #aeef01;
    }
`;

export const ErrorMessage = styled.div`
    padding: 20px;
    text-align: center;
    background: #fff2f0;
    border: 1px solid #ffccc7;
    border-radius: 8px;
    color: #cf1322;
    font-weight: 500;

    &::before {
        content: "⚠️";
        margin-right: 8px;
    }
`;

export const FooterContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
`;

export const DescriptionText = styled.div`
    color: #666;
    font-size: 14px;
    line-height: 1.5;
    padding: 12px 16px;
    background: #f8f9fa;
    border-radius: 6px;
    border-left: 4px solid #aeef01;
`;

export const ButtonGroup = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
    margin-top: 8px;
`;

export const DownloadButton = styled(Button)`
    &.ant-btn {
        background: #f0f9ff;
        border-color: #91d5ff;
        color: #1890ff;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-top: 4px;

        &:hover {
            background: #e6f7ff;
            border-color: #40a9ff;
            color: #096dd9;
            transform: translateY(-1px);
        }
    }
`;
